import { render } from "./CRMDatatableTDAdminName.vue?vue&type=template&id=8dddd680"
import script from "./CRMDatatableTDAdminName.vue?vue&type=script&lang=js"
export * from "./CRMDatatableTDAdminName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__